<template>
  <div class="navbar">
    <hamburger
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />

    <!-- <breadcrumb class="breadcrumb-container" /> -->
    <div>
      <div
        style="
          font-size: 18px;
          color: #999c9e;
          font-weight: 600;
          float: left;
          height: 100%;
          line-height: 50px;
        "
      >
        客服平台
      </div>
      <div
        v-if="isShowPkg"
        class="pkgList"
        style="margin-left: 20px; margin-top: 5px; float: left"
      >
        <el-select
          v-model="pkg"
          placeholder="请选择包名"
          style="width: 100%"
          @change="changePkg"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </div>

    <div class="right-menu">
      <div class="info"> {{role}} {{ name }} 在线</div>
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <img src="../../assets/img/avatar.png" class="user-avatar" />
          <i class="el-icon-caret-bottom" />
        </div>

        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <router-link to="/">
            <el-dropdown-item> Home </el-dropdown-item>
          </router-link>
          <el-dropdown-item divided @click.native="logout">
            <span style="display: block">Log Out</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";

export default {
  components: {
    Breadcrumb,
    Hamburger,
  },
  computed: {
    ...mapGetters(["sidebar", "avatar"]),
    name() {
      return localStorage.getItem("nickName");
    },
    isShowPkg() {
      if (this.$route.path === "/chat/index") {
        return true;
      } else {
        return false;
      }
    },
    role(){
      let info = JSON.parse(localStorage.getItem('userInfo'))
      if(info && info.user_type === 1){
        return '客服'
      }else{
        return '开发'
      }
    }
  },
  data() {
    return {
      options: [],
      pkgList: [],
      pkg: "",
    };
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    async logout() {
      await this.$store.dispatch("user/logout");
      localStorage.clear();
      this.$router.push(`/login`);
    },
    changePkg(val) {
      localStorage.setItem("curPkgIndex", val);
      this.$store.dispatch("app/changePkg", this.pkgList[val].pkg);
    },
  },
  mounted() {
    let _pkg = JSON.parse(localStorage.getItem("pkg"));
    let _res = [];
    if (_pkg !== null) {
      _pkg.map((item, index) => {
        _res.push({
          value: index,
          label:
            item.os === 0 ? item.group + " - Ios" : item.group + " - Android",
        });
      });
      this.options = _res;
      this.pkgList = _pkg;
      let _localPkgIndex = JSON.parse(localStorage.getItem('curPkgIndex'))
      if(_localPkgIndex){
        this.pkg = _localPkgIndex
      }else{
        this.pkg = 0;
      }
      let curPkg = this.pkgList[this.pkg]?.pkg || "";
      this.$store.dispatch("app/changePkg", curPkg);
    }
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  // box-shadow: 0 1px 4px rgba(0,21,41,.08);
  border-bottom: 1px solid #dddddd;

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    display: flex;
    align-items: center;
    .info {
      margin-right: 10px;
      color: #858684;
      font-size: 14px;
    }
    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        display: flex;
        align-items: center;
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 30px;
          height: 30px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          // top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
